<app-card-lg [title]="'Machines'">
  <div *appLoading="loading$ | async"></div>
  @if (!(loading$ | async)) {
    @for (machine of (machines$ | async); track machine) {
      <app-machines-list-item [machine]="machine"></app-machines-list-item>
    }
  }
</app-card-lg>
